export function createContact(input) {
    return fetch(config.apiRoot + "contact", {
        body: JSON.stringify(input),
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    });
}

let uploadingFiles = 0;

export function createFeedback(input) {
    return fetch(config.apiRoot + "feedback", {
        body: JSON.stringify(input),
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    });
}

function readFile(file) {
    return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.onerror = reject;
    });
}

export async function uploadFile(file, onLoading, onLoaded, onComplete) {
    const content = await readFile(file);
    try {
        ++uploadingFiles;
        onLoading();
        const response = await fetch(config.apiRoot + "screenshots", {
            method: "POST",
            body: JSON.stringify({ filename: file.name }),
            headers: {
                "Content-Type": "application/json",
            },
        });
        const raw = await response.json();
        const data = typeof raw === "string" ? JSON.parse(raw) : raw;
        onLoaded(data.key, content);
        await fetch(data.url, {
            method: "PUT",
            headers: {
                "Content-Type": file.type,
            },
            body: file,
        });
    } finally {
        if (!--uploadingFiles) {
            onComplete();
        }
    }
}
